import { Link } from 'react-router'

import Modal from '@/components/Modal'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import { AppStoreDownload, FuzzyCompact, Pattern, WatchdogCompact } from '@/assets'
import { colors } from '@/utils/theme'
import useBreakpoints from '@/hooks/useBreakpoints'
import { APP_STORE_MOBILE_URL } from '@/constants'

interface GetTheAppModalProps {
  isOpen: boolean
  onClose: () => void
}

function GetTheAppModal({ isOpen, onClose }: GetTheAppModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onCancel={onClose}
      style={{
        width: 642,
      }}
    >
      <img
        src={Pattern}
        alt='Background pattern'
        className='pattern'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }} />
      <GetTheAppModalContent />
    </Modal>
  )
}

export function GetTheAppModalContent() {
  const openLinkInNewTab = () => {
    window.open(APP_STORE_MOBILE_URL, '_blank', 'noopener,noreferrer')
  }

  const { isMobile } = useBreakpoints()

  return (
    <Flex
      align='center'
      justify='center'
      p={4} pb={1} gap={5}
      style={{ zIndex: 1 }}
    >
      <Flex gap={2} align='center'>
        <Text variant='h1' align='center' style={{ fontSize: '2rem' }}>Get our Apps!</Text>
        <Text align='center' style={{ hyphens: 'none' }}>
          Access the App Store to download the app to your mobile device.
        </Text>
      </Flex>
      <Flex wfull grid={!isMobile} align='center' gap={4} px={4}>
        <Flex
          align='center'
          justify='center'
          radius='medium'
          color='white'
          gap={2}
          p={3}
          style={{
            width: isMobile ? '100%' : 'auto',
            aspectRatio: !isMobile ? '1/1' : 'unset',
            border: `1px solid ${colors['gray-light-40']}`,
          }}
        >
          <FuzzyCompact width={75} height={75} style={{ minWidth: 75 }} className='brand' />
          <Text color='black-light-20'>Fuzzy Verify</Text>
          <Link
            to={APP_STORE_MOBILE_URL}
            onClick={openLinkInNewTab}
            style={{ textDecoration: 'none' }}
          >
            <AppStoreDownload style={{ width: '100%' }} />
          </Link>
        </Flex>
        <Flex
          align='center'
          justify='center'
          radius='medium'
          color='white'
          gap={2}
          p={3}
          style={{
            width: isMobile ? '100%' : 'auto',
            aspectRatio: !isMobile ? '1/1' : 'unset',
            border: `1px solid ${colors['gray-light-40']}`,
          }}
        >
          <WatchdogCompact width={75} height={75} style={{ minWidth: 75 }} className='brand' />
          <Text color='black-light-20'>Fuzzy Watchdog</Text>
          <Link
            to='/'
            // onClick={openLinkInNewTab}
            // Disabled until the app is available on the app store
            style={{
              textDecoration: 'none',
              pointerEvents: 'none',
              opacity: 0.5
            }}
          >
            <AppStoreDownload style={{ width: '100%' }} />
          </Link>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default GetTheAppModal
